import Sizes from "./Utils/Sizes"
import Time from "./Utils/Time"
import * as THREE from 'three'
import Camera from "./Camera"
import Renderer from "./Renderer"
import World from "./World/World"
import Resources from "./Utils/Resources.js"
import sources from "./sources"
import Debug from "./Utils/Debug.js"


let instance = null

export default class Experience
{
    constructor(canvas)
    {
        //Singleton
        if(instance)
        {
            return instance
        }
        instance = this

        //Global Access
        window.experience = this

        //Options
        this.canvas = canvas

        //Setup
        this.debug = new Debug()
        this.sizes = new Sizes()
        this.time = new Time()
        this.scene = new THREE.Scene()
        this.camera = new Camera()
        this.renderer = new Renderer()
        this.resources = new Resources(sources)
        this.world = new World()

        this.setLoadingScreen();
        this.setAudio();


        this.sizes.on("resize", () =>
        {
            this.resize()
        })

        this.time.on("tick", () =>
        {
            this.update()
        })
        
    }

    setLoadingScreen()
    {
        this.loadingText = document.getElementById("loading-text")
        this.loadingScreen = document.getElementById("loading-screen")
        this.loadingTextTitle = document.getElementById("lutin")
        this.button = document.getElementById("button")
        this.pereNoel = document.getElementById("pere-noel")

        this.resources.on("progress", () => {
            this.loadingText.textContent = `${this.resources.progress}%`
        });

        
        this.resources.on("loaded", () => {
            this.loadingText.style.display = "none"
            this.loadingTextTitle.style.display = "none"
            this.button.style.display = "visible"
            this.button.style.display = "block"
            this.pereNoel.style.display = "block"
        });

        button.addEventListener('click', () =>
        {
            this.loadingScreen.style.display = "none"
            this.button.style.display = "none"
            this.pereNoel.style.display = "none"
            this.setAudio()
        })
    }

    setAudio() 
    {
        this.resources.audio.play()
        this.resources.audio.loop = true
    }
    

    resize()
    {
        this.camera.resize()
        this.renderer.resize()
    }

    update()
    {
        this.camera.update()
        this.renderer.update()
        this.world.update()
    }
}